<template>
  <div class="page">
    <van-empty>
      <van-icon slot="image" size="108px" color="#00bb5a" name="checked" />
      <div class="page__title" slot="description">订阅成功</div>
      <div class="page__btn">
        <van-button @click="handleHome" block round type="primary" plain class="bottom-button">返回首页</van-button>
      </div>
    </van-empty>
  </div>
</template>
<script>
export default {
  name: 'job',
  data () {
    return {
    }
  },

  methods: {
    handleHome () {
      // eslint-disable-next-line no-undef
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    }
  }
}
</script>

<style lang="less" scoped>

.page {
  max-width: 750px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
  &__btn {
    width: 40vw;
  }
  &__title {
    font-size: 16px;
    color: #333;
  }
}
img {
  max-width: 100%;
}
</style>
